module.exports = __webpack_public_path__ + "static/media/Illus-Employee_3@2x.a43869a8.png";